import { ReactElement } from 'react';
import { useEntity, TabNav } from 'components';
import { NavLinkProps } from 'react-router-dom';
import { ServiceCategory } from 'modules/supplier/outletOrServiceCategory/types';

export function Nav(): ReactElement | null {
  const { item } = useEntity<ServiceCategory>();

  const nav: NavLinkProps[] = [
    {
      to: 'products',
      children: 'Products',
    },

    {
      to: '',
      end: true,
      children: 'Update',
    },
  ];

  return (
    <div className="container-fluid header ">
      <div className="d-flex flex-row align-items-center">
        <div className="mb-2">
          <h2>{item.name}</h2>
        </div>
      </div>
      <TabNav nav={nav} />
    </div>
  );
}
